import apiClient from "../../utils/apiClient";

const API_URL = "applications";

const getLegacyOptions = (legacyArg) => {
  if (!legacyArg || typeof legacyArg !== 'object' || Array.isArray(legacyArg)) {
    return {};
  }

  return legacyArg;
};

export async function submitApplication(serviceId, formData, token) {
  try {
    const config = {
      skipAuth: true
    };

    // Check if formData is FormData (contains files) or regular object
    if (formData instanceof FormData) {
      // For FormData (file uploads), let browser set Content-Type with boundary
      // Ensure serviceId is included in FormData
      if (!formData.has('serviceId')) {
        formData.append('serviceId', serviceId);
      }

      const response = await apiClient.post(`${API_URL}/submit`, formData, config);
      return response.data;
    } else {
      // For regular JSON data
      config.headers['Content-Type'] = 'application/json';
      const response = await apiClient.post(`${API_URL}/submit`, {
        serviceId,
        formData
      }, config);
      return response.data;
    }
  } catch (error) {
    console.error('Error in submitApplication:', error);
    throw error;
  }
}

export async function getUserApplications(token) {
  try {
    // Token will be added automatically by axios interceptor from localStorage
    const legacyOptions = getLegacyOptions(token);
    const requestUrl = legacyOptions.userId
      ? `${API_URL}/user/${legacyOptions.userId}`
      : `${API_URL}/user-applications`;

    const response = await apiClient.get(requestUrl);
    return response.data;
  } catch (error) {
    const legacyOptions = getLegacyOptions(token);
    if (!legacyOptions.silent) {
      console.error('Error fetching user applications:', error);
    }
    throw error;
  }
}

export async function getUserApplicationsByUserId(userId, options = {}) {
  try {
    const response = await apiClient.get(`${API_URL}/user/${userId}`, options.skipAuth ? { skipAuth: true } : undefined);
    return response.data;
  } catch (error) {
    if (!options.silent) {
      console.error('Error fetching user applications by userId:', error);
    }
    throw error;
  }
}

export async function getApplicationByNumberAndPhone(applicationNumber, phone) {
  try {
    const response = await apiClient.get(`${API_URL}/lookup`, {
      params: { applicationNumber, phone },
      skipAuth: true
    });
    return response.data;
  } catch (error) {
    console.error('Error looking up application:', error);
    throw error;
  }
}

export async function getApplicationDetails(applicationId, token) {
  const legacyOptions = getLegacyOptions(token);

  try {
    const config = {};

    if (legacyOptions.userId) {
      config.params = { userId: legacyOptions.userId };
    }

    if (legacyOptions.skipAuth) {
      config.skipAuth = true;
    }

    // Token will be added automatically by axios interceptor from localStorage
    const response = await apiClient.get(
      `${API_URL}/details/${applicationId}`,
      Object.keys(config).length > 0 ? config : undefined
    );
    return response.data;
  } catch (error) {
    if (!legacyOptions.silent) {
      console.error('Error fetching application details:', error);
    }
    throw error;
  }
}

export async function deleteApplication(applicationId, token) {
  try {
    // Token will be added automatically by axios interceptor from localStorage
    const response = await apiClient.delete(`${API_URL}/${applicationId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting application:', error);
    throw error;
  }
}

export async function reuploadApplicationDocument(applicationId, dataId, formData, token) {
  try {
    // Token will be added automatically by axios interceptor from localStorage
    const response = await apiClient.put(
      `${API_URL}/${applicationId}/reupload/${dataId}`,
      formData
    );

    return response.data;
  } catch (error) {
    console.error('Error reuploading application document:', error);
    throw error;
  }
}

export async function submitApplicationPayment({ upiId, applicationIds }) {
  try {
    const response = await apiClient.post('auth/submit-payment', {
      upiId,
      applicationIds
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting payment:', error);
    throw error;
  }
}

export async function getActivePaymentSettingForUser() {
  try {
    const response = await apiClient.get('auth/active-payment-setting');
    return response.data;
  } catch (error) {
    console.error('Error fetching active payment setting:', error);
    throw error;
  }
}

export async function getPublicPaymentData(token) {
  try {
    const response = await apiClient.get(`auth/public-payment/${encodeURIComponent(token)}`, {
      skipAuth: true
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching public payment data:', error);
    throw error;
  }
}